/**
 * isContractsEnabled.ts — DOC-03 two-layer legal gate
 *
 * SECURITY: Prevents a localStorage DevTools flip from unlocking contract
 * generation in production. Both layers must be true simultaneously:
 *   1. Build-time env: VITE_CONTRACTS_LEGAL_APPROVED=true (set only after documented
 *      Polish-lawyer sign-off per DOC-03)
 *   2. Runtime flag: useUIStore.getState().contractsLegalApproved === true
 *      (persisted in localStorage, default false)
 *
 * See threat T-07-01 in 07-01-PLAN.md.
 */

import { useUIStore } from '@/stores/useUIStore';

export function isContractsLegallyApproved(): boolean {
  const envApproved = import.meta.env['VITE_CONTRACTS_LEGAL_APPROVED'] === 'true';
  const runtimeApproved = useUIStore.getState().contractsLegalApproved;
  return envApproved && runtimeApproved;
}
